import { UploadPanel } from "~/components/common/upload/UploadPanel";
import Styles from "./TopArea.module.scss";

type Props = {
	handleDrop: (files: File[]) => Promise<void>;
};

export function TopArea({ handleDrop }: Props) {
	return (
		<div className={Styles.TopArea}>
			<div className={Styles.Uploading}>
				<UploadPanel accept={"image/*"} onDrop={handleDrop} />
			</div>
		</div>
	);
}
